module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.addressList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "goodType",
      "label": "货运类型",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.goodType(scope.row.goodType)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "国内仓地址",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.contacts) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.tel) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("修改")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "520px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "goodType",
      "label": "货物类型："
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    model: {
      value: (_vm.editDialog.data.goodType),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "goodType", $$v)
      },
      expression: "editDialog.data.goodType"
    }
  }, _vm._l((_vm.editDialog.goodTypeList), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "contacts",
      "label": "负责人姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人姓名",
      "minlength": "64"
    },
    model: {
      value: (_vm.editDialog.data.contacts),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "contacts", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel",
      "label": "负责人电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人电话",
      "minlength": "128"
    },
    model: {
      value: (_vm.editDialog.data.tel),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "tel", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "国内仓地址："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入国内仓地址：",
      "minlength": "300"
    },
    model: {
      value: (_vm.editDialog.data.address),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.address"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b8b0574"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/transport/list.vue
// module id = 1239
// module chunks = 2